var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2065 2.22852L10.9604 6.86756L12.1155 4.13059L17.2065 2.22852Z",
    fill: "#E2761B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78735 2.22852L8.98321 6.9115L7.88465 4.13059L2.78735 2.22852Z",
    fill: "#E4761B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9592 12.9819L13.2957 15.5306L16.855 16.5099L17.8782 13.0384L14.9592 12.9819Z",
    fill: "#E4761B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12817 13.0384L3.14512 16.5099L6.70445 15.5306L5.04092 12.9819L2.12817 13.0384Z",
    fill: "#E4761B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50356 8.67528L5.51172 10.1756L9.04593 10.3325L8.92038 6.53467L6.50356 8.67528Z",
    fill: "#E4761B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4903 8.67528L11.0421 6.49072L10.9604 10.3325L14.4884 10.1756L13.4903 8.67528Z",
    fill: "#E4761B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70435 15.5305L8.82613 14.4947L6.99311 13.0635L6.70435 15.5305Z",
    fill: "#E4761B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1677 14.4947L13.2958 15.5305L13.0007 13.0635L11.1677 14.4947Z",
    fill: "#E4761B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2958 15.5304L11.1677 14.4946L11.3372 15.8819L11.3184 16.4658L13.2958 15.5304Z",
    fill: "#D7C1B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70435 15.5304L8.68175 16.4658L8.66919 15.8819L8.82613 14.4946L6.70435 15.5304Z",
    fill: "#D7C1B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71312 12.147L6.94287 11.6259L8.19209 11.0547L8.71312 12.147Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2805 12.147L11.8015 11.0547L13.057 11.6259L11.2805 12.147Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7043 15.5306L7.00562 12.9819L5.04077 13.0384L6.7043 15.5306Z",
    fill: "#CD6116"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9944 12.9819L13.2957 15.5306L14.9592 13.0384L12.9944 12.9819Z",
    fill: "#CD6116"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4884 10.1758L10.9604 10.3327L11.2869 12.1469L11.8079 11.0546L13.0634 11.6259L14.4884 10.1758Z",
    fill: "#CD6116"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94274 11.6259L8.19823 11.0546L8.71298 12.1469L9.04569 10.3327L5.51147 10.1758L6.94274 11.6259Z",
    fill: "#CD6116"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51172 10.1758L6.9932 13.0634L6.94298 11.6259L5.51172 10.1758Z",
    fill: "#E4751F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0635 11.6259L13.0007 13.0634L14.4885 10.1758L13.0635 11.6259Z",
    fill: "#E4751F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04584 10.3325L8.71313 12.1467L9.12745 14.2873L9.22161 11.4687L9.04584 10.3325Z",
    fill: "#E4751F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9605 10.3325L10.791 11.4625L10.8663 14.2873L11.2869 12.1467L10.9605 10.3325Z",
    fill: "#E4751F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2868 12.147L10.8662 14.2876L11.1675 14.4948L13.0005 13.0635L13.0633 11.626L11.2868 12.147Z",
    fill: "#F6851B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94287 11.626L6.99309 13.0635L8.82611 14.4948L9.12743 14.2876L8.71312 12.147L6.94287 11.626Z",
    fill: "#F6851B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3183 16.4656L11.3371 15.8818L11.1802 15.7437H8.81357L8.66919 15.8818L8.68175 16.4656L6.70435 15.5303L7.39487 16.0952L8.79474 17.0683H11.199L12.6052 16.0952L13.2957 15.5303L11.3183 16.4656Z",
    fill: "#C0AD9E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1676 14.4948L10.8663 14.2876H9.12744L8.82613 14.4948L8.66919 15.8821L8.81357 15.744H11.1802L11.3371 15.8821L11.1676 14.4948Z",
    fill: "#161616"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4703 7.16888L18.0039 4.60767L17.2066 2.22852L11.1677 6.71062L13.4904 8.67547L16.7735 9.63592L17.5017 8.78847L17.1878 8.56248L17.69 8.10422L17.3008 7.8029L17.803 7.41998L17.4703 7.16888Z",
    fill: "#763D16"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99634 4.60767L2.52992 7.16888L2.19094 7.41998L2.69314 7.8029L2.31021 8.10422L2.81241 8.56248L2.49854 8.78847L3.22044 9.63592L6.50356 8.67547L8.82622 6.71062L2.7873 2.22852L1.99634 4.60767Z",
    fill: "#763D16"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7735 9.63575L13.4904 8.67529L14.4885 10.1756L13.0007 13.0632L14.9593 13.0381H17.8783L16.7735 9.63575Z",
    fill: "#F6851B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50356 8.67529L3.22045 9.63575L2.12817 13.0381H5.04092L6.99321 13.0632L5.51173 10.1756L6.50356 8.67529Z",
    fill: "#F6851B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9605 10.3325L11.1676 6.71041L12.1218 4.13037H7.88452L8.82614 6.71041L9.04585 10.3325L9.12118 11.475L9.12746 14.2873H10.8663L10.8789 11.475L10.9605 10.3325Z",
    fill: "#F6851B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.8ff10e7decab1e89ff1d66e93ff67210.svg";
export { ForwardRef as ReactComponent };